document.addEventListener("DOMContentLoaded", function () {
  if ($('.slideshow-banners .slide').length > 1) {
    $('.slideshow-banners').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      draggable: false,
      adaptiveHeight: true,
    });
  }
})